"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "modal-card"
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("Upload SDK")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.close
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_c("app-select", {
    attrs: {
      placeholder: "Tipo de Plataforma",
      label: "Tipo de Plataforma",
      error: _vm.$v.form.platformType.$error,
      items: _vm.listPlatformType,
      option: "id",
      "name-item": "name"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.platformType, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.platformType.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.platformType, "$model", $$v);
      },
      expression: "$v.form.platformType.$model"
    }
  }), _vm._v(" "), _c("app-input", {
    staticClass: "input-version",
    attrs: {
      label: _vm.uploadTexts.version,
      error: _vm.$v.form.version.$error
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.version, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.version.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.version, "$model", $$v);
      },
      expression: "$v.form.version.$model"
    }
  }), _vm._v(" "), _c("b-upload", {
    attrs: {
      "drag-drop": "",
      accept: _vm.acceptedFileTypes
    },
    on: {
      invalid: _vm.showInvalidFileMessage
    },
    model: {
      value: _vm.$v.form.file.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.file, "$model", $$v);
      },
      expression: "$v.form.file.$model"
    }
  }, [_c("section", {
    staticClass: "section full-width"
  }, [_c("div", {
    staticClass: "content has-text-centered"
  }, [_c("b-icon", {
    attrs: {
      icon: "file-document",
      size: "is-large"
    }
  }), _vm._v(" "), !_vm.form.file ? _c("p", [_vm._v(_vm._s(_vm.uploadTexts.dropzone))]) : _c("p", [_vm._v(_vm._s(_vm.form.file.name || "Arquivo selecionado"))])], 1)])]), _vm._v(" "), _vm.$v.form.file.$error && !_vm.$v.form.file.required ? _c("p", {
    staticClass: "help is-danger"
  }, [_vm._v("\n      " + _vm._s(_vm.uploadTexts.required) + "\n    ")]) : _vm.$v.form.file.$error && !_vm.$v.form.file.supportedFormat ? _c("p", {
    staticClass: "help is-danger"
  }, [_vm._v("\n      Formato não suportado. Envie um arquivo AAR, JS, Framework, XCFramework, DLL, EXE, MSI, DYLIB, DMG, PKG, PFX, P12, CER, CRT, PEM, DER, P7B, ZIP, RAR, 7Z, TAR, GZ, TGZ, BZ2 ou XZ.\n    ")]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "content-button"
  }, [_c("b-button", {
    attrs: {
      type: "is-info",
      loading: _vm.loading
    },
    on: {
      click: _vm.saveSDK
    }
  }, [_vm._v("\n        Salvar\n      ")])], 1)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;